import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import mentorshipIcon2 from "../../../../../assets/svg/dashboard/engagement-summary.svg";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import greyStartUp from "../../../../../assets/svg/greyStartUp.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import { Country, State, City } from "country-state-city";
import searchIcon from "../../../../../assets/images/searchIcon.svg";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import Pagination from "react-js-pagination";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import ModalFilters from "../../../../common/modalFilters/index";
import buttonSendMessage from "../../../../../assets/images/Icon_Chat_Message.svg";
import Select from "react-select";
import Button from "../../AdminDashboard/Button";
import { MY_MENTORSHIP_LIST } from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";

import {
  getStartupList,
  getMyStartupsCounter,
} from "../../StartupDashboard/dependencies/action";
import axios from "axios";
import {
  getPredefineOptionsList,
  getNamesList,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import modalDocUpload from "../../../../common/modalDocUpload";
import { Button as MaterialButton } from "@material-ui/core";
import ChatBoxModal from "../../../../common/chatBoxModal";
import mentorshipIcon from "../../../../../assets/svg/cohort_program_icon.svg";
import * as moment from "moment";
import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
import { PRODUCTION_MOVE_HIDDEN } from "../../../../common/constants/actionConstants";
import { types } from "../../../../common/dependencies/reducer/comingSoonReducer";
// import ChatBoxModal from "../../../../common/chatBoxModal";
const customStyles = {
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    maxWidth: "240px",
    // color: "#333",
    color: "rgb(121, 193, 206)",
    whiteSpace: "nowrap",
    fontSize: "18px",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
      whiteSpace: "nowrap",
      textAlign: "left",
    };
  },
};
const AllStartUpListMentor = (props) => {
  const {
    getStartupList,
    getMyStartupsCounter,
    tablePaginate,
    dataPagineate,
    getStartUpListData,
    startUpList,
    startUpListPagineate,
    getPredefineOptionsList,
    getPredefineOptions,
    getNamesListData,
    getNamesList,
    getStepperTooltipData,
    getStepperData,
  } = props;
  const history = useHistory();
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [activeText, setActiveText] = useState(true);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [filterName, setFilterName] = useState("");
  const [searchStartupId, setSearchStartupId] = useState("");

  const [nameListValue, setNameListValue] = useState([]);
  const newCountryArray = [];
  const newStateArray = [];
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [showSubmitAction, setShowSubmitAction] = useState(false);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const defaultFormData = {
    search: "",
    industry: "",
    specialization: "",
    stage: "",
    recognized: "",
    state: "",
    country: "",
  };

  const defaultFormData2 = {
    search: "",
    industry: "",
    specialization: "",
    stage: "",
    recognized: "",
    state: "",
    country: "",
  };

  const [formData, setFormData] = useState(defaultFormData);
  const [appliedformData, setAppliedFormData] = useState(defaultFormData2);
  const [tableList, setTableList] = useState();
  const [isParentData, setIsParentData] = useState(false);
  const [isModalShown, setIsModalShown] = useState(false);
  const [modalVisibility, setModalVisibility] = useState(false);
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const [indexCounter, setIndexCounter] = useState(0);
  const [startUpId, setStartUpId] = useState(0);
  const [data, setData] = useState();
  const [selectedRow, setSelectedRow] = useState("");
  const [allData, setAllData] = useState();
  const [dataCounter, setDataCounter] = useState(0);
  const [chatBoxModalOpen, setChatBoxModalOpen] = useState(false);
  const [mentorRequest, setMentorRequest] = useState();
  const [mentorRequestId, setMentorRequestId] = useState();
  const [isShown, setIsShown] = useState(false);
  const html = document.getElementsByTagName("html")[0];

  const loginrole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  if (loginrole === "Mentor" && !localStorage.getItem("setloggedin")) {
    localStorage.setItem("startupListMentor", "startupListMentor");
  } else if (loginrole === "Mentor" && localStorage.getItem("setloggedin")) {
    localStorage.removeItem("startupListMentor");
  } else {
    localStorage.removeItem("startupListMentor");
    history.push("/startup-dashboard");
  }

  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };

  useEffect(() => {
    // localStorage.setItem("startupListMentor", "startupListMentor");
    html.style.overflow = "auto";

    setTimeout(() => {
      localStorage.removeItem("mentorMentorships");
      localStorage.removeItem("cohortMentors");
      localStorage.removeItem("cohortStartup");
      localStorage.removeItem("myrequestMenu");
      localStorage.removeItem("cohortAdminMentorships");
      localStorage.removeItem("CohortMentorRequest");
      localStorage.removeItem("cohortApplicationMentor");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("cohortMatchTable");
      localStorage.removeItem("CohortGroupSession");

      // localStorage.removeItem("cohortMatchTable");
    }, 1000);
    getPredefineOptionsList();
  }, []);
  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);
  const getStartUpListDataNameSearch = (name) => {
    let params = {
      requestedBy: "",
      status: "",
      pageFilter: {
        currentPage: 0,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: name === "Select" ? "" : name,
      searchKey: null,
      country: "",

      mentorId:
        localStorage.getItem("SavedLoggedInData") &&
        JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      state: formData.state == "select" ? null : formData?.state?.value, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
    };
    getStartupList(params);
  };
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item, index) => {
      if (index === 0) {
        let arr2 = {
          value: "",
          label: "Select State",
        };
        newStateArray.push(arr2);
        setNewStateOptions((oldArray) => [...oldArray, arr2]);
      }
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);
  useEffect(() => {
    let nameArrList = [];
    // getNamesListData?.forEach((element, index) => {
    //   if (index === 0) {
    //     let arr2 = {
    //       value: "Select",
    //       label: "Select Startup",
    //     };
    //     setNameListValue((oldArray) => [...oldArray, arr2]);
    //   }
    //   let arr = {
    //     value: element.id,
    //     label: element.name,
    //   };
    //   if (getNamesListData.length >= nameListValue.length)
    //     setNameListValue((oldArray) => [...oldArray, arr]);
    // });
    if (getNamesListData !== undefined) {
      getNamesListData?.forEach((element, index) => {
        if (index === 0) {
          let arr2 = {
            value: "Select",
            label: "Select Startup",
          };
          // setNameListValue((oldArray) => [...oldArray, arr2]);
          nameArrList.push(arr2);
        }
        let arr = {
          value: element.id,
          label: element.name,
        };
        nameArrList.push(arr);
        // if (getNamesListData.length >= nameListValue.length)
        //   // setNameListValue((oldArray) => [...oldArray, arr]);
      });
      setNameListValue(nameArrList);
    }
  }, [getNamesListData]);
  const getStartupApplicationTable = () => {
    let params = {
      requestedBy: "",
      status: activeText3 ? "REQUESTSENT" : activeText2 ? "ACTIVE" : "",
      pageFilter: {
        currentPage: 0,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchKey: null,
      country: "",
      mentorId:
        localStorage.getItem("SavedLoggedInData") &&
        JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      state: formData.state == "select" ? null : formData?.state?.value, // optional
      searchField: searchStartupId === "Select" ? "" : searchStartupId,
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
    };
    getStartupList(params);
  };
  useEffect(() => {
    if (startUpList !== undefined && startUpList === null) {
      setAllData([]);
    } else if (startUpList !== undefined && startUpList !== null && activeText2)
      setAllData(startUpList);
    // setData(startUpList)
  }, [startUpList]);
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: "",
      state: "",
      industry: "", // optional
      function: "", // optional
      stage: "",
      mentorId:
        localStorage.getItem("SavedLoggedInData") &&
        JSON.parse(localStorage.getItem("SavedLoggedInData")).id,

      // searchField: formData.search ? formData.search : null,
      searchKey: null,
      status: activeText3 ? "REQUESTSENT" : activeText2 ? "ACTIVE" : "",
      searchField: searchStartupId === "Select" ? "" : searchStartupId,
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };
    getStartupList(params);
  };
  useEffect(() => {
    let params = {
      mentorId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    };
    getMyStartupsCounter(params);
  }, []);

  const getStartUpId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  const redirectProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/startup-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const ViewApplication = (item) => {
    let reRoute = window.open(`/view-StartupApplication/${item}`, "_blank");
    reRoute.id = item;
    reRoute.fromModule = "startUpApplications";
  };
  useEffect(() => {
    let value;
    value = JSON.parse(localStorage.getItem("SavedLoggedInData")).id;
    // axios({
    //   url: MY_MENTORSHIP_LIST,
    //   method: "POST",
    //   data: {
    //     mentorId: value,
    //   },
    // })
    api
      .POST(MY_MENTORSHIP_LIST, {
        mentorId: value,
      })
      .then((res) => {
        setData(res.data?.data);
        setDataCounter(res.data?.paginate);
      })
      .catch((err) => {});
  }, []);
  const getMyStartupListFn = (pageNumber) => {
    let value;
    setActivePage(1);
    value = JSON.parse(localStorage.getItem("SavedLoggedInData")).id;
    let params = {
      mentorId: value,
      searchField: searchStartupId === "Select" ? "" : searchStartupId,
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
      pageFilter: {
        currentPage:
          pageNumber !== undefined && pageNumber !== null && pageNumber !== ""
            ? pageNumber
            : 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };
    api
      .POST(MY_MENTORSHIP_LIST, params)
      .then((res) => {
        setData(res.data?.data);
        setDataCounter(res.data?.paginate);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    GetStartupList("", 0);
  }, []);
  const activeListFn = (pageNumber) => {
    getMyStartupListFn(pageNumber - 1);

    setActivePage(pageNumber);
  };
  const GetStartupList = (status, pageNumber) => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: "",
      state: "",
      industry: "", // optional
      function: "", // optional
      stage: "",
      // searchField: null,
      mentorId:
        localStorage.getItem("SavedLoggedInData") &&
        JSON.parse(localStorage.getItem("SavedLoggedInData")).id,

      status: status,
      searchField: searchStartupId === "Select" ? "" : searchStartupId,
      // searchField: formData.search ? formData.search : null,
      searchKey: null,
      pageFilter: {
        currentPage:
          pageNumber !== undefined && pageNumber !== null && pageNumber !== ""
            ? pageNumber
            : 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };
    getStartupList(params);
  };
  const getAppId = (string) => {
    if (string === undefined) return "-NA-";
    else {
      const value = string.substring(string.length - 6);
      return value;
    }
  };
  useEffect(() => {
    // request sent reload the table
    if (isParentData) {
      GetStartupList("", activePage);
      setIsParentData(false);
    }
  }, [isParentData]);
  return (
    <>
      <Modal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalData={modalData}
      />
      <ModalFilters
        // sendToParent={setIsParentData}
        modalVisibility={modalVisibility}
        setModalVisibility={setModalVisibility}
        fromModule="allStartupList"
        mentorID={JSON.parse(localStorage.getItem("SavedLoggedInData")).id}
        sendToParent={setIsParentData}
        startUpID={startUpId}
      />
      <div className="startuplistmentor">
        <div className="dashboard-main2" style={{ background: "none" }}>
          <div style={{ background: "transparent", border: "none" }}>
            {/* <MaterialButton
              className="topbackbtnactual top-btn"
              variant="contained"
              color="primary"
              onClick={handlePreviousPage}
            >
              {" "}
              Back
            </MaterialButton> */}
          </div>
          <div className="iconWith-heading startuplistheaddiv">
            <div style={{ width: "100%" }}>
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
                MENTOR DASHBOARD: ALL STARTUP LIST
              </h3>
            </div>
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";
              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>

        <div className="col-md-11 display-center mobileviewmentorreq">
          <div className="admin-bottom-card row mobileviewmentorbelow">
            <div
              className="mentorImageParent"
              style={{
                background: "none",
                border: "0px",
                borderRadius: "0px",
              }}
            >
              <img src={mentorshipIcon} className="sidebar-dashboard-icon2" />
            </div>
            {/* <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 mentorAppButton">
              <div className="dashboard-bottom-btn3">
                <p className="text-white">STARTUPS</p>
              </div>
            </div> */}
            <div className="dashboard-bottom-btn3 startuplistbtnmobile">
              <p className="text-white">STARTUPS</p>
            </div>
            <div class="w-20 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText(true);
                  setActiveText2(false);
                  setActiveText3(false);
                  setActivePage(1);
                  GetStartupList("", 0);
                  setFormData({
                    industry:null,
                    function:null,
                    stage:null,
                    name:null
                  });
                  // setFilterFunction(null);
                  // setFilterStage(null);
                  // setSearchStartupId(null);
                  // getCurrentList(1);
                }}
                style={{ color: activeText ? "#277acc" : "#838186" }}
                className="admindasheaderoptions"
              >
                {" "}
                ALL STARTUPS : {tablePaginate && tablePaginate?.total}
                {/* TOTAL STARTUPS : {dataPagineate?.totalElements} */}
                {/* {getCounter && getCounter.total} */}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "50px", width: "200px" }}
              >
                Click to View All Startup List
              </span>
              {activeText ? (
                <img src={LineWithDot} className="underline" />
              ) : (
                ""
              )}
            </div>

            <div class="w-20 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText3(true);
                  setActiveText(false);
                  setActiveText2(false);
                  setActivePage(1);
                  GetStartupList("REQUESTSENT", 0);
                  setFormData({
                    industry:null,
                    function:null,
                    stage:null,
                    name:null
                  });
                  //   getStartUpList("");
                  // getCurrentList(1);
                }}
                style={{ color: activeText3 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions"
              >
                {" "}
                MY REQUESTS : {tablePaginate && tablePaginate?.requestSent}
                {/* TOTAL STARTUPS : {dataPagineate?.totalElements} */}
                {/* {getCounter && getCounter.total} */}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "50px", width: "230px" }}
              >
                Click to View All Startup Requests
              </span>
              {activeText3 ? (
                <img src={LineWithDot} className="underline" />
              ) : (
                ""
              )}
            </div>
            <div class="w-20 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText(false);
                  setActiveText3(false);
                  setActiveText2(true);
                  // setSelectedStatus("ACTIVE");
                  // getCurrentList(0);
                  setActivePage(1);
                  GetStartupList("ACTIVE", 0);
                  setFormData({
                    industry:null,
                    function:null,
                    stage:null,
                    name:null
                  });
                }}
                style={{ color: activeText2 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions"
              >
                {" "}
                MY STARTUPS : {tablePaginate && tablePaginate?.myStartups}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "50px", width: "200px" }}
              >
                Click to View My Startup List
              </span>
              {activeText2 ? (
                <img src={LineWithDot} className="underline" />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="filter-row filter-row-common filterDivMentorapp">
            {/* <div className="container"> */}
            <div>
              <form className="formContainer">
                <div className="row desktopFilterRow hidestatecontetent">
                  {/* <div
                      className="col-md-1 filter-text3"
                      style={{
                        alignItems: "center",
                        display: "flex",
                        color: "#838186",
                        fontWeight: "400",
                        height: "40px",
                        fontSize: "18px",
                      }}
                    >
                      Filter by
                    </div> */}
                  <div className="col-8 d-flex justify-content-between filter-bigDiv">
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              name: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName(e.name);
                          setSearchStartupId(e.value);
                          getStartUpListDataNameSearch(e.value);
                        }}
                        options={nameListValue.length > 0 ? nameListValue : ""}
                        placeholder="Search Startup"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Startup
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Industry
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Function
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="stage"
                        // label="Gender*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Stage
                      </span>
                    </div>

                    {/* <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="state"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="state"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.state}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              state: e.value == "select" ? null : e,
                            };
                          });
                          setFilterState(e.value);
                        }}
                        options={newStateOptions}
                        placeholder="State"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search State
                      </span>
                    </div> */}
                  </div>

                  <div className="apply-section d-flex justify-content-end col-1 newuserTooltip">
                    <Button
                      // style={{
                      //   background: "#277acc",
                      // }}
                      // onClick={handleClickOfFilter}
                      // onClick={() => getStartupApplicationTable(selectedStatus)}
                      onClick={() => {
                        if (activeText2) {
                          getMyStartupListFn(activePage-1);
                        } else {
                          getStartupApplicationTable();
                        }
                      }}
                      text="GO"
                      className="filter-button top-btn newcoloredbtn startupColorBtn"
                    ></Button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        left: "46px",
                        width: "126px",
                        height: "48px",
                        top: "42px",
                      }}
                    >
                      Click to Apply Filters
                    </span>
                    {/* <Button
                      icon={<img src={arrow} className="search-icon" />}
                      text=""
                      onClick={() => getMentorApplications(selectedStatus)}
                      className="green-btn filter-btn apply-admin-dashbtn newfilterBtnallmentor"
                    /> */}
                  </div>
                </div>

                <div className="row mobileFilterRow">
                  <div className="col-md-1 filter-text">Filter by</div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="searchBy"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="searchBy"
                      className="col-12 gendermentorinput inputmblresmenreqstrtup"
                      styles={customStyles}
                      value={formData.name}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            name: e.name == "select" ? null : e,
                          };
                        });
                        setFilterName(e.name);
                        setSearchStartupId(e.value);
                        getStartUpListDataNameSearch(e.value);
                      }}
                      options={nameListValue.length > 0 ? nameListValue : ""}
                      placeholder="Search Startup"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput inputmblresmenreqstrtup"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>
                  {/* <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="country"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="country"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.country}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            country: e.value == "select" ? null : e,
                          };
                        });

                        setFilterCountry(e.label);

                        if (e.label === "India") {
                          setNewCountrySelect(true);
                        } else {
                          setNewCountrySelect(false);
                        }
                        setNewStateOptions("");
                      }}
                      options={newCountryOptions}
                      placeholder="Country"
                    />
                  </div> */}

                  {/* <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput inputmblresmenreqstrtup"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                  </div> */}
                  <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button
                      className="green-btn filter-btn"
                      onClick={() => {
                        if (activeText2) {
                          getMyStartupListFn(activePage-1);
                        } else {
                          getStartupApplicationTable();
                        }
                      }}
                      text="GO"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="totalTableCount">
            Total Mentors Found:{" "}
            {activeText == true ||
            (activeText3 == true && startUpList !== undefined)
              ? startUpListPagineate?.totalElements
              : dataCounter?.totalElements}{" "}
            &lt;{" "}
            {activeText == true ||
            (activeText3 == true && startUpList !== undefined)
              ? startUpListPagineate?.currentPage
              : dataCounter?.currentPage}{" "}
            of{" "}
            {activeText == true ||
            (activeText3 == true && startUpList !== undefined)
              ? startUpListPagineate?.numPages
              : dataCounter?.numPages}{" "}
            &gt;{" "}
            {/* Total Mentors Found: {dataPagineate?.totalElements} &lt;
            {dataPagineate?.currentPage} of{" "}
            {dataPagineate?.numPages} &gt;{" "} */}
          </div>
          <div>
            <div className="table-container mt-2">
              {/* <table className="table table-bordered" style={{fontSize:"16px"}}>
                {(activeText == true || activeText3 == true) &&
                startUpList !== undefined && */}
              <table
                className="table table-bordered"
                style={{ fontSize: "16px" }}
              >
                {/* {(activeText == true || activeText3 == true) &&
                startUpList !== undefined && startUpList !== null &&
                startUpList?.length > 0 ? ( */}
                {(activeText == true || activeText3 == true) &&
                startUpList !== undefined &&
                startUpList !== null &&
                startUpList?.length > 0 ? (
                  <>
                    <thead>
                      <tr>
                        <th className="tableJustify fixColumbnWidth4">NO.</th>
                        <th className="fixColumbnWidth" colspan="2">
                          STARTUP
                        </th>
                        {/* {activeText2 ? (
                         ""
                       ) : (
                         <th style={{ whiteSpace: "nowrap" }}>DPIIT ID</th>
                       )} */}

                        <th style={{ whiteSpace: "nowrap" }}>DPIIT ID</th>

                        <th>CITY</th>
                        {/* <th>PROFILE</th> */}
                        {!activeText2 ? (
                          ""
                        ) : (
                          <th style={{ minWidth: "8.5rem" }}>MESSAGE</th>
                        )}
                        {!activeText2 ? "" : <th>MENTORSHIPS</th>}
                        {activeText2 ? "" : <th>SEND REQUEST</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {startUpList !== undefined &&
                        startUpList.map((item, index) => (
                          <tr
                            key={index}
                            className={
                              item.id === indexCounter ? "purpleBackground" : ""
                            }
                          >
                            {startUpListPagineate.currentPage === 1 ? (
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    // height: "100px",
                                  }}
                                  className="srnomendshallstrtuplistmbl"
                                >
                                  {index + 1}
                                </div>
                              </td>
                            ) : (
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    // height: "100px",
                                  }}
                                >
                                  {index +
                                    1 +
                                    10 * (startUpListPagineate.currentPage - 1)}
                                </div>
                              </td>
                            )}
                            <td
                              style={{
                                // flexDirection: "row",
                                display: "flex",
                                // justifyContent: "center",
                              }}
                              className="mendshallstrtuplistdetailsmbl"
                            >
                              <div
                                className="newuserTooltip"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  maxWidth: "none",
                                  objectFit: "contain",
                                }}
                              >
                                <img
                                  src={
                                    item.logo === null ? hashImage : item.logo
                                  }
                                  onClick={() => {
                                    setIndexCounter(item.id);
                                    redirectProfile(item.dippNumber);
                                  }}
                                  // src={
                                  //   "https://holmesbuilders.com/wp-content/uploads/2016/12/male-profile-image-placeholder.png"
                                  // }
                                  className="sidebar-dashboard-icon2"
                                  style={{
                                    width: "100%",
                                    cursor: "pointer",
                                    height: "100%",
                                    // maxWidth: "none",
                                    objectFit: "contain",
                                  }}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    left: "50px",
                                    top: "90px",
                                    width: "150px",
                                  }}
                                >
                                  View Startup Profile
                                </span>
                                <div
                                  style={{
                                    flexDirection: "row",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    height: "100px",
                                    // maxWidth: "240px",
                                  }}
                                  className="mendashallstrtuplstdetailsinner"
                                >
                                  <div
                                    style={{
                                      cursor: "default",
                                      alignItems: "center",
                                      display: "flex",
                                      minWidth: "100%",
                                      textAlign: "right",
                                    }}
                                  >
                                    {item.name}
                                  </div>
                                  <div
                                    className="d-flex justify-content-end newuserTooltip"
                                    style={{
                                      cursor: "pointer",

                                      alignItems: "start",
                                      justifyContent: "center",
                                      height: "100px",
                                      minWidth: "100%",
                                      display: "flex",
                                    }}
                                    onClick={() => {
                                      setIndexCounter(item.id);
                                      redirectProfile(item.dippNumber);
                                    }}
                                  >
                                    <img src={profile} width="40px" />
                                    {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-info-circle"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                  </svg> */}
                                    <span
                                      className="tooltiptext tooltip-bottom"
                                      style={{
                                        left: "20px",
                                        top: "105px",
                                        width: "150px",
                                      }}
                                    >
                                      View Startup Profile
                                    </span>
                                    {/* <span className="tooltiptext-profile tooltip-bottomx">
                            View Startup Profile
                          </span> */}
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td
                              style={{ minWidth: "300px" }}
                              className="mendashmenstrtuplistmblnoshow"
                            >
                              <div
                                style={{
                                  flexDirection: "row",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  height: "100px",
                                  // maxWidth: "240px",
                                }}
                              >
                                <div
                                  style={{
                                    cursor: "default",
                                    alignItems: "center",
                                    display: "flex",
                                    minWidth: "400px",
                                  }}
                                >
                                  {item.name}
                                </div>
                                <div
                                  className="d-flex justify-content-end newuserTooltip"
                                  style={{
                                    cursor: "pointer",

                                    alignItems: "end",
                                    justifyContent: "center",
                                    height: "100px",
                                    minWidth: "40px",
                                    display: "flex",
                                  }}
                                  onClick={() => {
                                    setIndexCounter(item.id);
                                    redirectProfile(item.dippNumber);
                                  }}
                                >
                                  <img src={profile} />
                                  {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-info-circle"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                  </svg> */}
                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      left: "20px",
                                      top: "105px",
                                      width: "150px",
                                    }}
                                  >
                                    View Startup Profile
                                  </span>
                                  {/* <span className="tooltiptext-profile tooltip-bottomx">
                            View Startup Profile
                          </span> */}
                                </div>
                              </div>

                              {/* {item.applicant_name} */}
                            </td>

                            <td>
                              <div
                                className="newuserTooltip"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  height: "100px",
                                  justifyContent: "left",
                                }}
                              >
                                <a
                                  onClick={() => {
                                    ViewApplication(item.dippNumber);
                                    setIndexCounter(item.id);
                                  }}
                                  className="color-green"
                                >
                                  {item.dippNumber}
                                </a>

                                {item.dippNumber === null ||
                                item.dippNumber === undefined ||
                                item.dippNumber === "" ? (
                                  ""
                                ) : (
                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      left: "70px",
                                      width: "130px",
                                      top: "75px",
                                    }}
                                  >
                                    View Application
                                  </span>
                                )}
                              </div>
                            </td>

                            <td style={{ minWidth: "11rem" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  height: "100px",
                                  justifyContent: "left",
                                }}
                                className="citymendshallstrtuplstmbl"
                              >
                                {item.city}
                              </div>
                            </td>
                            {/* <td>
                              <div className="newuserTooltip">
                                <a
                                  onClick={() => {
                                    setIndexCounter(item.id);
                                    ViewProfile(item.dippNumber);
                                  }}
                                  className="color-green"
                                >
                                  View
                                </a>
                                <span className="tooltiptext viewStartupprofile tooltip-bottom">
                                  View Profile
                                </span>
                              </div>
                            </td>
                            */}

                            <td style={{ minWidth: "11rem" }}>
                              {!item.requestSent ? (
                                <div
                                  className="newuserTooltip "
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    height: "100px",
                                    justifyContent: "left",
                                  }}
                                >
                                  <a
                                    onClick={() => {
                                      if (PRODUCTION_MOVE_HIDDEN) {
                                        props.comingSoonOpen();
                                        return;
                                      }
                                      setIndexCounter(item.id);
                                      setModalVisibility(true);
                                      setStartUpId(item.id);
                                    }}
                                    className="color-green"
                                  >
                                    Send Request
                                  </a>
                                  <span
                                    className="tooltiptext  tooltip-bottom"
                                    style={{ left: "70px", top: "75px" }}
                                  >
                                    Send Request
                                  </span>
                                </div>
                              ) : (
                                <div
                                  className="mendshallstrtuplistsndreqmbl"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    height: "100px",
                                    // justifyContent: "left",
                                  }}
                                >
                                  {/* <br></br> */}
                                  <div
                                    className="mt-2"
                                    style={{ width: "80%" }}
                                  >
                                    {item?.requestStatus &&
                                    item?.requestStatus === "Ongoing Mentorship"
                                      ? "Mentorship Ongoing"
                                      : item?.requestStatus}
                                    <br></br>

                                    {/* Request Sent */}

                                    {item?.requestStatus &&
                                    item?.requestStatus === "Ongoing Mentorship"
                                      ? ""
                                      : item?.requestDate !== null &&
                                        item?.requestDate !== undefined &&
                                        item?.requestDate !== "" &&
                                        moment(item?.requestDate).format(
                                          "DD/MM/YYYY "
                                        )}
                                  </div>
                                  {item?.requestStatus &&
                                  item?.requestStatus ===
                                    "Ongoing Mentorship" ? (
                                    <div
                                      style={{
                                        height: "100px",
                                        paddingRight: "0px",
                                      }}
                                      className="d-flex justify-content-end newuserTooltip cohort-programIcons sndreqiconmndshallstrtuplistmbl"
                                      onClick={() => {
                                        // if (item?.mentorshipId !== null) {
                                        window.open(
                                          `/mentor-dashboard/mentorships/engagement-summary/${item?.mentorship?.id}`,
                                          "_blank"
                                        );
                                      }}
                                    >
                                      <img
                                        style={{
                                          width: "40px",
                                          height: "40px",
                                        }}
                                        src={mentorshipIcon2}
                                        height={40}
                                      />
                                      <span
                                        className="tooltiptext tooltip-bottom "
                                        style={{
                                          left: "14px",
                                          top: "103px",
                                          width: "150px",
                                          height: "auto",
                                        }}
                                      >
                                        View Engagement
                                        <br></br>
                                        Summary
                                      </span>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </>
                ) : (activeText == true || activeText3 == true) &&
                  startUpList !== undefined &&
                  startUpList?.length === 0 ? (
                  <tr colSpan={8} style={{ border: "none" }}>
                    <td
                      className="d-flex justify-content-center"
                      style={{ border: "none" }}
                    >
                      {" "}
                      <div
                        className="no-records"
                        style={{ position: "relative", left: "" }}
                      >
                        No Records Found
                      </div>
                    </td>
                  </tr>
                ) : startUpList !== undefined &&
                  startUpList !== null &&
                  startUpList?.length > 0 ? (
                  <>
                    <thead>
                      <tr>
                        <th className="tableJustify fixColumbnWidth4">NO.</th>
                        <th className="fixColumbnWidth" colspan="2">
                          STARTUP
                        </th>
                        {/* {activeText2 ? (
                         ""
                       ) : (
                         <th style={{ whiteSpace: "nowrap" }}>DPIIT ID</th>
                       )} */}

                        <th style={{ whiteSpace: "nowrap" }}>DPIIT ID</th>

                        <th>CITY</th>
                        {/* <th>PROFILE</th> */}
                        {!activeText2 ? (
                          ""
                        ) : (
                          <th style={{ minWidth: "8.5rem" }}>MESSAGE</th>
                        )}
                        {!activeText2 ? "" : <th>MENTORSHIPS</th>}
                        {activeText2 ? "" : <th>REQUEST STATUS</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {console.log("TABLEDATA", data)}
                      {data.map((item, index) => (
                        <tr
                          key={index}
                          className={
                            item.id === indexCounter ? "purpleBackground" : ""
                          }
                        >
                          <td>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                // height: "100px",
                              }}
                            >
                              {index + 1 + 10 * (dataCounter.currentPage - 1)}
                              {/* {index + 1} */}
                            </div>
                          </td>
                          <td
                            style={{
                              // flexDirection: "row",
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              className="newuserTooltip"
                              style={{
                                width: "100px",
                                height: "100px",
                                maxWidth: "none",
                                objectFit: "contain",
                              }}
                            >
                              <img
                                src={
                                  item?.startup?.logo === undefined ||
                                  item?.startup?.logo === null ||
                                  item?.startup?.logo === ""
                                    ? hashImage
                                    : item?.startup?.logo
                                }
                                onClick={() => {
                                  setIndexCounter(item?.id);
                                  redirectProfile(item?.startup?.dippNumber);
                                }}
                                // src={
                                //   "https://holmesbuilders.com/wp-content/uploads/2016/12/male-profile-image-placeholder.png"
                                // }
                                className="sidebar-dashboard-icon2"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  cursor: "pointer",
                                  // maxWidth: "none",
                                  objectFit: "contain",
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{
                                  left: "45px",
                                  top: "85px",
                                  width: "150px",
                                }}
                              >
                                View Startup Profile
                              </span>
                            </div>
                          </td>
                          <td
                            style={{ minWidth: "27.9rem", maxWidth: "28rem" }}
                          >
                            <div
                              style={{
                                flexDirection: "row",
                                display: "flex",
                                justifyContent: "space-between",
                                height: "100px",
                                // maxWidth: "240px",
                              }}
                            >
                              <div
                                style={{
                                  cursor: "default",
                                  alignItems: "center",
                                  display: "flex",
                                  maxWidth: "240px",
                                }}
                              >
                                {item?.startup?.name}
                              </div>
                              <div
                                className="d-flex justify-content-end newuserTooltip"
                                style={{
                                  cursor: "pointer",

                                  alignItems: "end",
                                  justifyContent: "center",
                                  height: "100px",
                                  minWidth: "40px",
                                  display: "flex",
                                }}
                                onClick={() => {
                                  setIndexCounter(item?.id);
                                  redirectProfile(item?.startup?.dippNumber);
                                }}
                              >
                                <img src={profile} />
                                {/* <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    className="bi bi-info-circle"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                  </svg> */}

                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    left: "21px",
                                    top: "102px",
                                    width: "150px",
                                  }}
                                >
                                  View Startup Profile
                                </span>
                                {/* <span className="tooltiptext-profile tooltip-bottomx">
                            View Startup Profile
                          </span> */}
                              </div>
                            </div>

                            {/* {item.applicant_name} */}
                          </td>

                          <td>
                            <div className="mt-2">
                              <div
                                className="newuserTooltip"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "left",
                                }}
                              >
                                <a
                                  onClick={() => {
                                    ViewApplication(item?.startup?.dippNumber);
                                    setIndexCounter(item?.startup?.id);
                                  }}
                                  className="color-green"
                                >
                                  {item?.startup?.dippNumber}
                                </a>

                                {item?.startup?.dippNumber === null ||
                                item?.startup?.dippNumber === undefined ||
                                item?.startup?.dippNumber === "" ? (
                                  ""
                                ) : (
                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      left: "44px",
                                      width: "150px",
                                      top: "33px",
                                    }}
                                  >
                                    View Application
                                  </span>
                                )}
                              </div>
                              <div className="mt-2">
                                {moment(
                                  item?.mentorRequest?.mentorAcceptDate
                                ).format("DD/MM/YYYY ")}
                              </div>

                              {item?.mentorRequest?.searchId !== null &&
                                item?.mentorRequest?.searchId !== undefined && (
                                  <div
                                    className="newuserTooltip  "
                                    style={{
                                      display: "flex",
                                      justifyContent: "left",
                                      maxWidth: "3.2rem",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <a
                                      onClick={() => {
                                        setIndexCounter(item?.id);
                                        setModalData(
                                          item?.mentorRequest?.requestJson
                                        );
                                        setModalOpen(true);
                                      }}
                                      className="color-green"
                                    >
                                      {getAppId(item?.mentorRequest?.searchId)}
                                    </a>

                                    {/* {getAppId(item.mentorRequest)} */}
                                    <span
                                      className="tooltiptext tooltip-bottom"
                                      style={{
                                        left: "6px",
                                        top: "33px",
                                        width: "221px",
                                      }}
                                    >
                                      View Mentorship Requirement
                                    </span>
                                  </div>
                                )}
                            </div>
                          </td>

                          <td>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                height: "100px",
                                justifyContent: "left",
                              }}
                            >
                              {item?.startup?.city}
                            </div>
                          </td>
                          {/* <td>
                              <a
                                onClick={() => {
                                  setIndexCounter(item.id);
                                  ViewProfile(item.startup.dippNumber);
                                }}
                                className="color-green"
                              >
                                View
                              </a>
                            </td> */}
                          {activeText2 ? (
                            <td
                              style={{
                                // flexDirection: "row",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {/* <div
                                className="newuserTooltip"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  height: "100px",
                                  justifyContent: "left",
                                }}
                              >
                                <a
                                  onClick={() => {
                                    setIndexCounter(item.id);
                                  }}
                                  className="color-green"
                                >
                                  Send Message
                                </a>
                                <span
                                  className="tooltiptext  tooltip-bottom"
                                  style={{ left: "70px", top: "75px" }}
                                >
                                  Send Message
                                </span>
                              </div> */}
                              <div
                                className="newuserTooltip"
                                style={{
                                  width: "50px",
                                  height: "100px",
                                  maxWidth: "none",
                                  objectFit: "contain",
                                }}
                              >
                                <img
                                  src={buttonSendMessage}
                                  // src={
                                  //   "https://holmesbuilders.com/wp-content/uploads/2016/12/male-profile-image-placeholder.png"
                                  // }
                                  className="sidebar-dashboard-icon2"
                                  style={{
                                    width: "80%",
                                    height: "100%",
                                    cursor: "pointer",
                                    // maxWidth: "none",
                                    // objectFit: "contain",
                                  }}
                                  onClick={() => {
                                    setIndexCounter(item?.id);
                                    setChatBoxModalOpen(true);
                                    setMentorRequest(item?.startup);
                                    setMentorRequestId(item?.startup?.id);
                                  }}
                                />
                                <span
                                  className="tooltiptext  tooltip-bottom"
                                  style={{
                                    left: "25px",
                                    width: "120px",
                                    top: "80px",
                                  }}
                                >
                                  Send Message
                                </span>
                              </div>
                            </td>
                          ) : (
                            ""
                          )}
                          {activeText2 ? (
                            <td>
                              {item?.mentorRequest?.searchId !== null &&
                                item?.mentorRequest?.searchId !== undefined && (
                                  <div
                                    className="d-flex newuserTooltip"
                                    style={{
                                      cursor: "pointer",
                                      justifyContent: "center",
                                      height: "50px",
                                      width: "40px",
                                      display: "flex",
                                      position: "relative",
                                      top: "1.5rem",
                                      left: "4rem",
                                    }}
                                  >
                                    <img
                                      src={mentorshipIcon2}
                                      alt={item.title}
                                      onClick={() => {
                                        window.open(
                                          `/mentor-dashboard/mentorships/engagement-summary/${item?.mentorRequest?.mentorshipId}`,
                                          "_blank"
                                        );
                                      }}
                                    />
                                    <span
                                      className="tooltiptext tooltip-bottom"
                                      style={{
                                        width: "140px",
                                        top: "53px",
                                        left: "10px",
                                        height: "50px",
                                      }}
                                    >
                                      View Mentorship Engagement
                                    </span>
                                  </div>
                                )}
                            </td>
                          ) : (
                            ""
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </>
                ) : (
                  <tr colSpan={8} style={{ border: "none" }}>
                    <td
                      className="d-flex justify-content-center tdclass"
                      style={{ border: "none" }}
                    >
                      {" "}
                      <div
                        className="no-records"
                        // style={{ position: "relative", left: "24rem" }}
                      >
                        No Records Found
                      </div>
                    </td>
                  </tr>
                )}
                {/* {data !== undefined &&
                    data.map((item, index) => (
                      <tr
                        key={index}
                        className={
                          item.id === indexCounter ? "purpleBackground" : ""
                        }
                      >
                        <td>{index+1}</td>
                        <td>{item.applicant_name}</td>
                        <td>{item.city}</td>
                        <td>
                          <a
                            onClick={() => {
                              setIndexCounter(item.id);
                              ViewProfile(item.dippNumber);
                            }}
                            className="color-green"
                          >
                            View
                          </a>
                        </td>
                        <td>
                          <a
                            onClick={() => {
                              setIndexCounter(item.id);
                            }}
                            className="color-green"
                          >
                            View
                          </a>
                        </td>
                        
                      </tr>
                    ))} */}
              </table>

              <div className="pagination-box">
                {
                  startUpList !== undefined && (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={
                        activeText2
                          ? dataCounter?.totalElements
                          : dataPagineate?.totalElements
                      }
                      pageRangeDisplayed={5}
                      onChange={
                        activeText2
                          ? activeListFn.bind(this)
                          : handlePageChange.bind(this)
                      }
                    />
                  )
                  //  : (
                  //   <Pagination
                  //     activePage={activePage}
                  //     itemsCountPerPage={10}
                  //     totalItemsCount={dataPagineate?.totalElements}
                  //     pageRangeDisplayed={5}
                  //     onChange={activeListFn.bind(this)}
                  //   />
                  // )
                }

                {/* {(data !== undefined && data.length) > 0 ? (
                  <Pagination
                    activePage={activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={dataPagineate.totalElements}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange.bind(this)}
                  />
                ) : (
                  ""
                )} */}
              </div>
              <ChatBoxModal
                modalVisibility={chatBoxModalOpen}
                setModalVisibility={setChatBoxModalOpen}
                receiverInfo={mentorRequest}
                receiverId={mentorRequestId}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.StartUpReducer.AllStartUpList.data,
    dataPagineate: state.StartUpReducer.AllStartUpList.paginate,
    startUpList: state.StartUpReducer.AllStartUpList.data,
    startUpListPagineate: state.StartUpReducer.AllStartUpList.paginate,
    tablePaginate: state.StartUpReducer.myStartupsCounter.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};

const comingSoonOpen = () => (dispatch) => {
  dispatch({ type: types.SET_OPEN });
};

export default connect(mapStateToProps, {
  getStartupList,
  getPredefineOptionsList,
  getNamesList,
  comingSoonOpen,
  getMyStartupsCounter,
  getStepperTooltipData,
})(withRouter(AllStartUpListMentor));